(function () {
  var drawer = null;
  var overlay = null;
  var itemsContainer = null;
  var emptyState = null;
  var subtotal = null;
  var status = null;
  var closeTimer = null;
  var lastFocusedElement = null;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormatWithCurrency || theme.moneyFormat);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateCartCount(count) {
    Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (countElement) {
      countElement.textContent = count;
    });

    Array.prototype.slice.call(document.querySelectorAll('[data-cart-count-bubble]')).forEach(function (bubble) {
      bubble.classList.toggle('hide', count <= 0);
    });
  }

  function propertyMarkup(properties) {
    if (!properties) return '';

    return Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && properties[key] !== null && properties[key] !== '';
    }).map(function (key) {
      return '<li>' + escapeHtml(key) + ': ' + escapeHtml(properties[key]) + '</li>';
    }).join('');
  }

  function renderItem(item) {
    var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="santi-cart-drawer__variant">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    var properties = propertyMarkup(item.properties);
    var propertiesList = properties ? '<ul class="santi-cart-drawer__properties">' + properties + '</ul>' : '';

    return [
      '<li class="santi-cart-drawer__item">',
        '<a class="santi-cart-drawer__image" href="' + escapeHtml(item.url || '/cart') + '">' + image + '</a>',
        '<div class="santi-cart-drawer__item-copy">',
          '<a class="santi-cart-drawer__item-title" href="' + escapeHtml(item.url || '/cart') + '">' + escapeHtml(item.product_title || item.title) + '</a>',
          variant,
          propertiesList,
          '<div class="santi-cart-drawer__item-meta">',
            '<span>Qty ' + item.quantity + '</span>',
            '<strong>' + formatMoney(item.final_line_price || item.line_price || 0) + '</strong>',
          '</div>',
        '</div>',
      '</li>'
    ].join('');
  }

  function renderCart(cart) {
    var items = cart && cart.items ? cart.items : [];

    if (itemsContainer) {
      itemsContainer.innerHTML = items.map(renderItem).join('');
    }

    if (emptyState) {
      emptyState.hidden = items.length > 0;
    }

    if (subtotal) {
      subtotal.textContent = formatMoney(cart ? cart.total_price : 0);
    }

    if (status) {
      status.textContent = items.length > 0 ? 'Cart updated.' : 'Your cart is empty.';
    }

    updateCartCount(cart ? cart.item_count : 0);
  }

  function fetchCart() {
    if (status) status.textContent = 'Loading cart.';

    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function () {
        if (status) status.textContent = 'Cart could not be loaded. Use the Go to cart link to view your cart.';
        return { items: [], item_count: 0, total_price: 0 };
      });
  }

  function showDrawer(options) {
    options = options || {};

    if (!drawer || !overlay) return Promise.resolve();

    window.clearTimeout(closeTimer);
    lastFocusedElement = document.activeElement;

    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('santi-cart-drawer-open');

    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.focus();
    });

    return fetchCart().then(function () {
      if (options.autoClose) {
        closeTimer = window.setTimeout(function () {
          closeDrawer({ restoreFocus: false });
        }, options.autoCloseDelay || 2600);
      }
    });
  }

  function closeDrawer(options) {
    options = options || {};

    if (!drawer || !overlay) return;

    window.clearTimeout(closeTimer);
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('santi-cart-drawer-open');

    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) {
        overlay.hidden = true;
      }
    }, 220);

    if (options.restoreFocus !== false && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function bindCartIcon() {
    Array.prototype.slice.call(document.querySelectorAll('a.site-header__cart')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!window.SantiCartDrawer) return;
        event.preventDefault();
        showDrawer({ autoClose: false });
      });
    });
  }

  function bindCloseControls() {
    Array.prototype.slice.call(document.querySelectorAll('[data-santi-cart-drawer-close]')).forEach(function (button) {
      button.addEventListener('click', function () {
        closeDrawer();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDrawer();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  function init() {
    drawer = document.querySelector('[data-santi-cart-drawer]');
    overlay = document.querySelector('[data-santi-cart-drawer-overlay]');
    itemsContainer = document.querySelector('[data-santi-cart-drawer-items]');
    emptyState = document.querySelector('[data-santi-cart-drawer-empty]');
    subtotal = document.querySelector('[data-santi-cart-drawer-subtotal]');
    status = document.querySelector('[data-santi-cart-drawer-status]');

    if (!drawer || !overlay) return;

    window.SantiCartDrawer = {
      open: showDrawer,
      close: closeDrawer,
      refresh: fetchCart
    };

    bindCartIcon();
    bindCloseControls();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
